// Función para formatear RUT (XX.XXX.XXX-X)
export const formatRut = (rut) => {
  // Eliminar puntos y guión
  let valor = rut.replace(/\./g, '').replace(/-/g, '');
  
  // Eliminar caracteres no válidos
  valor = valor.replace(/[^0-9kK]/g, '');

  // Obtener dígito verificador
  let dv = valor.slice(-1);
  // Obtener cuerpo del RUT
  let rutNumeros = valor.slice(0, -1);
  
  if (rutNumeros.length > 0) {
    // Formatear números con puntos
    rutNumeros = rutNumeros.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    
    // Agregar guión y dígito verificador
    return rutNumeros + '-' + dv;
  }
  
  return valor;
};

// Función para validar RUT chileno
export const validateRut = (rut) => {
  if (typeof rut !== 'string') {
    return false;
  }

  // Eliminar puntos y guión
  const rutLimpio = rut.replace(/\./g, '').replace(/-/g, '');

  if (rutLimpio.length < 2) {
    return false;
  }

  // Obtener dígito verificador
  const dv = rutLimpio.slice(-1).toLowerCase();
  // Obtener cuerpo del RUT
  const rutNumeros = parseInt(rutLimpio.slice(0, -1), 10);

  if (isNaN(rutNumeros)) {
    return false;
  }

  // Calcular dígito verificador
  const calcularDv = (rutNumeros) => {
    let suma = 0;
    let multiplicador = 2;
    let rutReverso = rutNumeros.toString().split('').reverse();

    for (let digit of rutReverso) {
      suma += parseInt(digit) * multiplicador;
      multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
    }

    const resultado = 11 - (suma % 11);
    if (resultado === 11) return '0';
    if (resultado === 10) return 'k';
    return resultado.toString();
  };

  return dv === calcularDv(rutNumeros);
}; 